import { ChooseFeedTypeList } from "./ChooseFeedTypeList";

export default ChooseFeedTypeList;
